import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
/* src/app/page.dashboard/view.scss: no such file or directory */`],
})
export class PageDashboardComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public uploads: any[] = [];
    public page: number = 1;
    public total: number = 0;
    public dump: number = 10;
    public uploading: boolean = false;
    public uploadStatus: string = '';
    public dragOver: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.loadList();
    }

    public async loadList() {
        let { code, data } = await wiz.call("list", { page: this.page, dump: this.dump });
        if (code === 200) {
            this.uploads = data.rows || [];
            this.total = data.total || 0;
        }
        await this.service.render();
    }

    public onDragOver(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = true;
    }

    public onDragLeave(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
    }

    public async onDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            await this.handleFile(files[0]);
        }
    }

    public async onFileSelect(event: any) {
        const files = event.target?.files;
        if (files && files.length > 0) {
            await this.handleFile(files[0]);
        }
        event.target.value = '';
    }

    public async handleFile(file: File) {
        if (!file.name.toLowerCase().endsWith('.csv')) {
            await this.service.modal.show({
                title: '',
                message: 'CSV 파일만 업로드할 수 있습니다.',
                cancel: false,
                actionBtn: 'error',
                action: '확인',
                status: 'error'
            });
            return;
        }

        this.uploading = true;
        this.uploadStatus = '파일 업로드 중...';
        await this.service.render();

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch(`/wiz/api/page.dashboard/upload`, {
                method: 'POST',
                body: formData
            });
            const result = await response.json();

            if (result.code === 200) {
                this.uploadStatus = '분석 완료!';
                await this.service.render();
                setTimeout(() => {
                    this.service.href(`/report/${result.data.upload_id}`);
                }, 500);
            } else {
                this.uploadStatus = '';
                this.uploading = false;
                await this.service.render();
                await this.service.modal.show({
                    title: '',
                    message: result.data?.message || '업로드에 실패했습니다.',
                    cancel: false,
                    actionBtn: 'error',
                    action: '확인',
                    status: 'error'
                });
            }
        } catch (e) {
            this.uploadStatus = '';
            this.uploading = false;
            await this.service.render();
        }
    }

    public async deleteUpload(id: string, event: any) {
        event.stopPropagation();
        let result = await this.service.modal.show({
            title: '',
            message: '이 업로드 기록을 삭제하시겠습니까?',
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!result) return;

        let { code } = await wiz.call("delete", { id: id });
        if (code === 200) {
            await this.loadList();
        }
    }

    public goReport(upload: any) {
        if (upload.status === 'completed') {
            this.service.href(`/report/${upload.id}`);
        }
    }

    public async changePage(p: number) {
        this.page = p;
        await this.loadList();
    }

    public get totalPages() {
        return Math.ceil(this.total / this.dump);
    }

    public statusLabel(status: string) {
        const map: any = { uploading: '업로드 중', analyzing: '분석 중', completed: '완료', failed: '실패' };
        return map[status] || status;
    }

    public statusColor(status: string) {
        const map: any = { completed: 'text-emerald-600 bg-emerald-50', analyzing: 'text-blue-600 bg-blue-50', uploading: 'text-yellow-600 bg-yellow-50', failed: 'text-red-600 bg-red-50' };
        return map[status] || 'text-gray-600 bg-gray-50';
    }

    public formatDate(d: string) {
        if (!d) return '-';
        return d.substring(0, 16);
    }

    public formatPeriod(start: string, end: string) {
        if (!start || !end) return '-';
        return start.substring(0, 10) + ' ~ ' + end.substring(0, 10);
    }
}

export default PageDashboardComponent;